import {Form} from "./form";
import netRequests from "./netRequests";
import initDropDownsPrograms from "./initDropDownsPrograms";

let form;

const initForm = () => {
  form = new Form();
  
  window.form = form;
  form.init();

  async function initNetRequests() {
    const allPrograms = await netRequests();

    // MARKDEV-1079 Костыль перемещения программ в форме заявки
    const promptengineer = allPrograms.programs.splice(allPrograms.programs.indexOf(allPrograms.programs.find(program => program.shortname == "promptengineer")), 1)[0];

    if (promptengineer) {
      allPrograms.programs.splice(0, 0, promptengineer);
    }

    const psychologist = allPrograms.programs.splice(allPrograms.programs.indexOf(allPrograms.programs.find(program => program.shortname == "psychologist")), 1)[0];

    if (psychologist) {
      allPrograms.programs.splice(1, 0, psychologist);
    }
    
    initDropDownsPrograms(allPrograms.programs, allPrograms.regions);
  }

  initNetRequests();
};

export {form, initForm};
